import { createContext, ReactNode, useContext, useState } from "react";

interface ThemeContextType {
  theme: "dark" | "light";
  toggleDarkMode: () => void;
}

interface ThemeProviderProps {
  children: ReactNode;
}

const ThemeContext = createContext<ThemeContextType | null>(null);

/**
 *  The current theme and a function to toggle the theme
 * @returns {{
 *  theme: "dark" | "light";
 *  toggleDarkMode: () => void;
 * }}
 */
export const useDarkSide = (): ThemeContextType => {
  const context = useContext(ThemeContext);

  if (!context) {
    throw new Error("useDarkSide must be used within a ThemeProvider");
  }

  return context;
};

export default function ThemeProvider({ children }: ThemeProviderProps) {
  const [theme, setTheme] = useState<ThemeContextType["theme"]>(() => {
    // const savedTheme = localStorage.getItem(
    //   "theme"
    // ) as ThemeContextType["theme"];

    return "light";
  });

  // useEffect(() => {
  //   const root: HTMLElement = window.document.documentElement;

  //   if (theme === "dark") {
  //     root.classList.add("dark");
  //   } else {
  //     root.classList.remove("dark");
  //   }
  //   localStorage.setItem("theme", theme);
  // }, [theme]);

  const toggleDarkMode = () => {
    setTheme("light");
  };
  // const toggleDarkMode = () => {
  //   setTheme((prev) => (prev === "light" ? "dark" : "light"));
  // };

  return (
    <ThemeContext.Provider
      value={{
        theme,
        toggleDarkMode,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
}
